export default [
  {
    title: 'Familiebeheer',
    icon: 'UsersIcon',
    route: 'family-management',
  },
]
